/**
 * Save-as-you-go resume for Costs & Margin guided questions (per project).
 */

const PREFIX = 'ci.costsMargin.progress.v2.'

export type CostsMarginProgress = {
  currentIndex: number
  skippedIds: string[]
  updatedAt: string
}

export function progressStorageKey(projectId: number): string {
  return `${PREFIX}${projectId}`
}

export function loadProgress(projectId: number): CostsMarginProgress | null {
  try {
    const raw = localStorage.getItem(progressStorageKey(projectId))
    if (!raw) return null
    const parsed = JSON.parse(raw) as CostsMarginProgress
    if (!parsed || typeof parsed.currentIndex !== 'number') return null
    return {
      currentIndex: Math.max(0, parsed.currentIndex),
      skippedIds: Array.isArray(parsed.skippedIds) ? parsed.skippedIds.map(String) : [],
      updatedAt: parsed.updatedAt || new Date().toISOString(),
    }
  } catch {
    return null
  }
}

export function saveProgress(projectId: number, state: Omit<CostsMarginProgress, 'updatedAt'>): void {
  try {
    const payload: CostsMarginProgress = {
      ...state,
      updatedAt: new Date().toISOString(),
    }
    localStorage.setItem(progressStorageKey(projectId), JSON.stringify(payload))
  } catch {
    /* private browsing */
  }
}

export function clearProgress(projectId: number): void {
  try {
    localStorage.removeItem(progressStorageKey(projectId))
  } catch {
    /* ignore */
  }
}
